import React from 'react';
import propTypes from 'prop-types';
import { concatClassName } from '@dateam/ark-react';
import styles from './Topbar.module.scss';

type Props = {
    className?: string;
    children?: React.ReactNode;
};

const Topbar: React.FC<Props> = ({
    className,
    children
}: Props) => (
    <aside className={concatClassName(styles['topbar'], className)}>
        {children}
    </aside>
);

Topbar.propTypes = {
    className: propTypes.string,
    children: propTypes.node
};

Topbar.defaultProps = {
    className: undefined,
    children: undefined
};

export default Topbar;
